import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"
import { useFieldControl } from "@/components/ds/Field"

/**
 * The field look every text control shares (Input, Textarea, NativeSelect,
 * the Select trigger) is one class, .tk-field (index.css): white, a #8A94A6
 * edge (3.06:1, a field you can see), 12px radius, 16px ink text so iOS
 * never zooms, a muted placeholder. Focus is a 2px ink edge (red is kept for
 * errors); an invalid field (aria-invalid, which <Field> sets) has a 2px red
 * edge and, focused, the site's red ring around it. Utilities passed in
 * className still win over the class at rest.
 */
export const fieldControlClasses = "tk-field"

/**
 * Heights: md 44 (forms; the default, unchanged), lg 48 (the system's
 * standard field beside a 48px button), search 56 (--tk-field-h, the search
 * panels). `size` also still accepts the native number (characters wide).
 */
const inputVariants = cva(
  cn(fieldControlClasses, "flex px-3.5 py-2 file:border-0 file:bg-transparent file:text-body-md file:font-medium file:text-foreground"),
  {
    variants: {
      size: {
        md: "h-11",
        lg: "h-12",
        search: "h-14",
      },
    },
    defaultVariants: { size: "md" },
  }
)

const Input = React.forwardRef(({ className, type, size, ...props }, ref) => {
  const control = useFieldControl(props)
  const native = typeof size === "number" ? size : undefined
  return (
    <input
      type={type}
      size={native}
      className={cn(inputVariants({ size: typeof size === "string" ? size : undefined }), className)}
      ref={ref}
      {...control} />
  );
})
Input.displayName = "Input"

export { Input, inputVariants }
